<template>
  <div class="Inspection5">
    <h1 id="heading">Bewertung des Höhenunterschieds und Höhenprofils</h1>
    <v-divider></v-divider>
    <div>
      <v-data-table
        :headers="headers"
        :items-per-page="5"
        :items="items"
        item-key="tableRow"
        class="DataTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
            <td class="text-xs-left" style="font-size: 120%">{{ props.item.rowID }}</td>
            <td>
              <input
                type="radio"
                v-model="assessment"
                :key="props.item.rowID"
                :value="props.item.rowID"
              >
            </td>
            <td>
              <div class="description">
                <v-dialog v-model="dialog" max-width="700px" :retain-focus="false">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="green"
                      slot="activator"
                      x-small fab
                      v-on="on"
                      @click="selectInfo(props.item.rowID)"
                    >
                      <v-icon color="white" small>fas fa-info</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="green" height="50px">
                      <v-toolbar-title
                        style="color: white; font-size: 150%"
                      >Höhenunterschied und Höhenprofil</v-toolbar-title>

                      <v-spacer></v-spacer>

                      <v-btn @click="close" small icon>
                        <v-icon color="white">fas fa-times</v-icon>
                      </v-btn>
                    </v-toolbar>

                    <v-img :src="imgSrc"></v-img>
                    <v-divider></v-divider>
                  </v-card>
                </v-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <v-btn color="blue" @click="nextPage" small fab>
        <v-icon color="white">fas fa-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inspection5",
  props: ["assessmen"],
  data() {
    return {
      assessment: 0,
      assessName: "",
      assessHeader: "",
      imgSrc: "",
      tableRow: 0,
      dialog: false,
      items: [
        { name: "Höhenunterschied unter 250m und horizontale Länge unter 1.000m", rowID: 0 },
        {
          name:
            "Höhenunterschied 250m bis 600m ODER Höhenunterschied unter 250m bei horizontaler Länge über 1.000m",
          rowID: 1
        },
        { name: "Höhenunterschied 600m bis 1.200m", rowID: 2 },
        {
          name: "Höhenunterschied über 1.200m",
          rowID: 3
        }
      ],
      headers: [
        {
          text: "Litzenseile",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Relative Bewertung", sortable: false, align: "left", value: "assess" },
        {sortable: false},
        { text: "Info", sortable: false, align: "center" }
      ]
    };
  },
  methods: {
    nextPage() {
      switch (this.assessment) {
        case 0:
          this.assessName = "Höhenunterschied unter 250m und horizontale Länge unter 1.000m";
          break;
        case 1:
          this.assessName =
            "Höhenunterschied 250m bis 600m ODER Höhenunterschied unter 250m bei horizontaler Länge über 1000m";
          break;
        case 2:
          this.assessName = "Höhenunterschied 600m bis 1200m";
          break;
        case 3:
          this.assessName = "Höhenunterschied 600m bis 1200m";
      }
      this.assessmen = this.assessmen + this.assessment;
      this.assessHeader = "Höhenunterschied und Höhenprofil";

      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    },
    close() {
      this.dialog = false;
    },
    selectInfo(row) {
      var o = this.items.find(x => x.rowID === row);
      var index = this.items.indexOf(o);

      switch (index) {
        case 0:
          this.imgSrc = require("../../statics/images/hoehenunterschied1.png");
          break;
        case 1:
          this.imgSrc = require("../../statics/images/hoehenunterschied2.png");
          break;
        case 2:
          this.imgSrc = require("../../statics/images/hoehenunterschied3.png");
          break;
        case 3:
          this.imgSrc = require("../../statics/images/hoehenunterschied4.png");
          break;
      }
    }
  },
  created() {
    var ropeType = this.$store.state.facilityList.find(x => x.id == this.$store.state.inspectingFacilityID).ropeList.find(x => x.id == this.$store.state.inspectingRopeID).rope;
    if (ropeType.includes("vollverschlossen")) {
      this.assessment = 0;
      this.$emit("assessChanged", this.assessmen);
      this.$emit("assessmentName", this.assessName);
      this.$emit("assessmentHeader", this.assessHeader);
      this.$emit("assessmentActual", this.assessment);
      this.$emit("InspBefore", false);
      this.$emit("InspActual", true);
    }
  }
};
</script>

<style>
.Inspection5 {
  background-color: white;
  width: 70%;
  margin: 1% auto 0% auto;
  border: 1px solid black;
  border-radius: 5px;
  text-align: center;
}

.DataTable {
  width: 90%;
  margin-left: 5%;
}

#heading {
  font-size: 200%;
}
</style>
